export const PINK = {
  LIGHTER: '#ffe5ed',
} as const;
